import { globalGetService } from '@/utils/globalApiServices';

export const download = async (
  attachmentUuid: string,
  fileProps: { filename: string }
) => {
  const { filename } = fileProps;
  const response = await globalGetService(
    `dca/attachments/download?attachmentUuid=${encodeURIComponent(
      attachmentUuid
    )}`,
    {},
    { responseType: 'arraybuffer' }
  );
  return response?.ok
    ? {
        file: new File([response.data as ArrayBuffer], filename, {
          type: response.headers['content-type'] || 'application/octet-stream',
        }),
      }
    : undefined;
};
